import { createThread, editThread } from '@/app/models/forum/forum-cta'
import { ForumTypeEnum } from '@/app/models/forum/new-forum.model'
import { CtaGroupWrapper } from '../UI/CtaGroup/CtaGroupWrapper'

interface ForumCtaProps {
    type?: ForumTypeEnum
    onCta: (action: string) => void
}

const ForumCta = ({ type, onCta }: ForumCtaProps) => {
    const ctaConfig = !type ? createThread() : editThread()
    return <CtaGroupWrapper ctaConfig={ctaConfig} ctaHandler={onCta} />
}

export default ForumCta
